import { jsx as d, Fragment as b } from "react/jsx-runtime";
import { useState as p, useEffect as m, createContext as A, useContext as w, Suspense as g, lazy as y } from "react";
import { d as P } from "./AiAssistRail-Cjw4mUF4.js";
const v = (e) => (e == null ? void 0 : e.propertiesValues) ?? {}, R = async (e, t) => {
  const n = [], s = [], o = [];
  let a = !1, l = null, c = t.getOrder();
  for (const r of e)
    try {
      if (r.kind === "set") {
        const i = t.getGraphic(r.playlistGraphicId);
        if (!i) throw new Error("that graphic is no longer in the playlist");
        const u = await t.setFields(i.id, {
          ...v(i),
          ...r.fields
        });
        u && s.push(u), o.push(i.id);
      } else {
        const i = t.getTemplate(r.templateId);
        if (!i) throw new Error("that template can no longer be placed in this rundown");
        const u = await t.createGraphic({
          templateId: i.id,
          ...r.name ? { name: r.name } : {},
          fields: r.fields
        });
        if (!u) throw new Error("the graphic came back empty");
        a = !0, r.afterPosition === void 0 ? c = [...c, u.id] : (c = [
          ...c.slice(0, r.afterPosition),
          u.id,
          ...c.slice(r.afterPosition)
        ], await t.reorder(c));
      }
      n.push(r.id);
    } catch (i) {
      l = i instanceof Error ? i.message : "the change was refused";
      break;
    }
  return { applied: n, updated: s, written: o, hasPlaced: a, failure: l };
}, E = 4e3, f = /* @__PURE__ */ new Map(), S = (e) => {
  const { origin: t } = new URL(e);
  return `${t}/healthz`;
}, k = (e) => {
  const t = S(e), n = f.get(t);
  if (n) return n;
  const s = (async () => {
    const o = new AbortController(), a = setTimeout(() => o.abort(), E);
    try {
      return (await fetch(t, { signal: o.signal, credentials: "omit" })).ok;
    } catch {
      return !1;
    } finally {
      clearTimeout(a);
    }
  })();
  return f.set(t, s), s;
}, x = (e) => {
  const t = !!(e != null && e.trim()), [n, s] = p(t ? "probing" : "disabled");
  return m(() => {
    if (!(e != null && e.trim())) {
      s("disabled");
      return;
    }
    let o = !0;
    return s("probing"), k(e).then((a) => {
      o && s(a ? "available" : "unavailable");
    }).catch(() => {
      o && s("unavailable");
    }), () => {
      o = !1;
    };
  }, [e]), n;
}, h = A(null), G = h.Provider, _ = () => {
  const e = w(h);
  if (!e)
    throw new Error("Ask is mounted outside AiAssistHostProvider; wrap it and supply the host.");
  return e;
}, T = y(
  () => import("./GraphicsPanel-BUdF3KPg.js").then((e) => ({ default: e.GraphicsPanel }))
), I = ["superadmin", "beta"], M = ({ children: e, apiUrl: t, host: n }) => {
  const s = x(t), o = s === "available" && I.some((a) => {
    var l;
    return (l = n.roles) == null ? void 0 : l.includes(a);
  }) && n.rundown !== null;
  return s === "disabled" ? /* @__PURE__ */ d(b, { children: e }) : /* @__PURE__ */ d(G, { value: n, children: /* @__PURE__ */ d(
    P,
    {
      isAvailable: o,
      buttonTitle: "Ask about this rundown",
      renderPanel: (a) => /* @__PURE__ */ d(g, { fallback: null, children: /* @__PURE__ */ d(T, { apiUrl: t, onClose: a }) }),
      children: e
    }
  ) });
};
export {
  M as G,
  R as e,
  _ as u
};
//# sourceMappingURL=index-C_yHhkdl.js.map
